skrilla.controller('permissionsModalCtrl', function ($scope, searchService, cacheService, modalService, adminService) {
    $scope.mode = "edit";
    $scope.permissions = [
        {name : "viewUser", text: "View Users"}, {name : "editUser", text: "Edit Users"},
        {name : "viewContest", text: "View Contests"}, {name : "editContest", text: "Edit Contests"},
        {name : "createContest", text: "Create Contests"}, {name : "resultContest", text: "Result Contests"},
        {name : "cancelContest", text: "Cancel Contests"}, {name : "publishContest", text: "Publish Contests"},
        {name : "viewBet", text: "View Bets"}, {name : "editBet", text: "Edit Bets"},
        {name : "viewBettingMarkets", text: "View Betting Markets"}, {name : "editBettingMarkets", text: "Edit Betting Markets"},
        {name : "manageProviders", text: "Manage connections to Odds providers"},
        {name : "viewData", text: "View Data"}, {name : "editData", text: "Edit Data"},
        {name : "viewFinancials", text: "View Financials"}, {name : "editFinancials", text: "Edit Financials"},
        {name : "viewAccounts", text: "View Accounts"}, {name : "editAccounts", text: "Edit Accounts"},
        {name : "viewAdmin", text: "View Admins"}, {name : "editAdmin", text: "Edit Admins"},
        {name : "viewManualTransaction", text: "View Manual Transactions"}, {name : "editManualTransaction", text: "Edit Manual Transactions"},
        {name : "viewWithdrawal", text: "View Withdrawals"}, {name : "editWithdrawal", text: "Edit Withdrawals"},
        {name : "viewMarketPlace", text: "View Market Place"}, {name : "editMarketPlace", text: "Edit Market Place"},
        {name : "viewLimit", text: "View Limits"}, {name : "editLimit", text: "Edit Limits"},
        {name : "viewPromotion", text: "View Promotions"}, {name : "editPromotion", text: "Edit Promotions"},
        {name : "viewAffiliate", text: "View Affiliates"}, {name : "editAffiliate", text: "Edit Affiliates"},
        {name : "viewSkrillaJobs", text: "View Skrilla Jobs"}, {name : "editSkrillaJobs", text: "Edit Skrilla Jobs"},
        {name : "editContestState", text: "Edit Contest State"}, {name: "editUserMigration", text: "Edit User Migration"},
        {name : "viewQuartzJobs", text: "View Quartz Jobs"},
        {name : "editQuartzJobs", text: "Edit Quartz Jobs"},
        {name : "viewConfig", text: "View Config"}, {name : "editConfig", text: "Edit Config"},
        {name: "viewPPI", text: "View PPI"},
        {name: "editBettingMarketCategories", text: "Edit Betting Market Categories"},
        {name: "reOpenExcludedUser", text: "Re Open Excluded Users"},
    ];
    var role = cacheService.getObject("role");
    if(Object.keys(role).length === 0 && role.constructor === Object){
        $scope.mode = "create";
    }
    else{
        $scope.role = {name: role.name};
        console.log(role);
        role.permissions.forEach(function(rolePermission){
            $scope.permissions.forEach(function(permission){
               if(permission.name === rolePermission){
                   permission.selected = true;
               }
            });
        });
    }

    $scope.selectAll = function(){
        $scope.selected = !$scope.selected;
        $scope.permissions.forEach(function(role){
            role.selected = $scope.selected;
        });
    }

    $scope.cancel = function(){modalService.dismissAll();}

    $scope.savePermissions = function(){
        var permissionsArr = [];
        $scope.permissions.forEach(function(permission){
            if(permission.selected === true) permissionsArr.push(permission.name);
        });
        if($scope.mode === "create") {
            searchService.post('roles', {
                name: $scope.role.name,
                permissions: permissionsArr
            }, "Role permissions Successfully updated!").then(function successCallback(response) {
                adminService.getAdmin(true);
                modalService.dismissAll();
            });
        }
        else{
            role.permissions = permissionsArr;
            role.name = $scope.role.name;
            console.log(role);
            searchService.put("roles/" + role.id, role.permissions, "Role Successfully updated!").then(function(response){
                adminService.getAdmin(true);
                modalService.dismissAll();
            });
        }
    }

});

